import { render } from "./QueueDetailTableOutboundAnswered.vue?vue&type=template&id=5070ef3d"
import script from "./QueueDetailTableOutboundAnswered.vue?vue&type=script&lang=js"
export * from "./QueueDetailTableOutboundAnswered.vue?vue&type=script&lang=js"

import "./QueueDetailTableOutboundAnswered.vue?vue&type=style&index=0&id=5070ef3d&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__